<script>
import Base from "@/components/RequestDetails/RequestTickets.vue";

export default {
  name: "CustomerServiceRequestTickets",
  extends: Base,
};
</script>

